// Agregar width(obj) y permisos a cada componente
<template>
  <div id="custom_dashboard_settings_loading" class="vs-con-loading__container">
    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="center" vs-w="12">
      <draggable :list="chartData" group="charts1" class="p-2 cursor-move">
        <vs-col
          v-for="(el, index) in chartData"
          :key="index"
          class="p-2"
          :vs-xs="el.width.xs"
          :vs-sm="el.width.sm"
          :vs-lg="el.width.lg"
        >
          <vx-card
            :title="$t(el.title) | capitalize"
            v-show="hasPermission(el.can)"
            class="img-widget-card"
          >
            <template slot="actions" >
              <feather-icon
                :icon="el.active ? 'EyeIcon' : 'EyeOffIcon'"
                :svgClasses="[
                  'h-5 w-5 mr-4 hover:text-primary cursor-pointer',
                  el.active ? 'text-success' : 'text-primary',
                ]"
                @click="el.active = !el.active"
              />
            </template>
            <div class="img-widget-box">
              <img
                :src="el.img"
                :class="['img-widget',!el.active ? 'disabled' : '']"
              />
            </div>
          </vx-card>
        </vs-col>
      </draggable>
    </vs-row>
    <!-- </vs-row> -->
    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="center" vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" vs-sm="8">
        <vs-button size="large" @click="submit">{{ $t('save') | capitalize }}</vs-button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import charts from './charts'
import dashboard from './request/dashboard'
import loading from '@/mixins/Loading'
export default {
  components: {
    draggable,
  },
  mixins: [loading],
  computed: {
    isLoading() {
      return this.loading.settings || this.loading.submit
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`custom_dashboard_settings_loading`)
      } else {
        this.closeLoading(`custom_dashboard_settings_loading`)
      }
    },
  },
  data() {
    return {
      charts: charts,
      userData: [
        { id: 'DiscrepanciesTypeTreemap', active: false },
        { id: 'DiscrepanciesSupplierDonut', active: false },
        { id: 'DiscrepanciesClientBar', active: false },
        { id: 'LoadOrderStatusCards', active: false },
        { id: 'EntriesWarehouseDonut', active: false },
        { id: 'EntriesAgingDonut', active: false },
        { id: 'EntriesStatusCards', active: false },
        { id: 'EhsTable', active: false },
        { id: 'EhsStatusDonut', active: false },
        { id: 'ComplianceTable', active: false },
        { id: 'ComplianceStatusDonut', active: false },
        { id: 'AccountingRejectedDonut', active: false },
        { id: 'AccountingInvoicedDonut', active: false },
        { id: 'AccountingPendingDonut', active: false },
        { id: 'ReviewOrderBarClient', active: false },
        { id: 'ReviewOrdersCardsStatus', active: false },
        { id: 'ReviewOrdersDonutStatus', active: false },
      ],
      chartData: [],
      loading: {
        settings: false,
        submit: false,
      },
    }
  },
  methods: {
    submit() {
      this.loading.submit = true
      let settings = this.chartData.map((el) => ({
        id: el.id,
        active: el.active,
      }))
      let params = { settings: settings }
      dashboard
        .updateSettings(params)
        .then((response) => {
          console.log(response)
          this.loading.submit = false
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: response.data.message
          })
          this.$router.replace({ name: 'dashboard' })
          //this.$router.push({ name: 'dashboard' })
        })
        .catch((err) => {
          console.log(err)
          this.loading.submit = false
        })
    },
    mergeArray(a1, a2) {
      return a1.map((t1) => ({ ...t1, ...a2.find((t2) => t2.id === t1.id) }))
    },
    getUserData() {
      this.loading.settings = true
      dashboard
        .getUserData()
        .then((response) => {
          if (response.data.settings !== null) {
            this.userData = JSON.parse(response.data.settings)
          }
          this.chartData = this.mergeArray(this.userData, this.charts)
          console.log(this.chartData)
          this.loading.settings = false
        })
        .catch((err) => {
          this.loading.settings = false
          console.log(err)
        })
    },
  },
  mounted() {
    this.getUserData()
  },
}
</script>

<style>
img.disabled {
  opacity: 0.3;
}
</style>